



































































































// Vue
import { Vue, Component, Prop } from 'vue-property-decorator'

// Components
import { CheckBox, Select, Radio } from '@/components/form'
import { DataTable } from '../../table'

// models
import { PropOptionRadio, PropOptionSelect } from '@/models'
import { AssistanceDevice, SaveAssistanceDeviceForm } from '@/models/assistance'

// constants
import { OPTIONS_TYPES_MARKING } from '@/constants'

// utils
import { alerts, loading } from '@/utils'
import { AssistanceService } from '@/services/assistance'

@Component({
    name: 'TableListAssistancesDevice',
    components: {
        DataTable,
        CheckBox,
        Select,
        Radio
    }
})
export default class TableListAssistancesDevice extends Vue {
    @Prop({ required: true, type: Array }) readonly assistances!: AssistanceDevice[]
    @Prop({ required: true }) readonly device!: number|null
    @Prop({ default: 0, type: Number }) readonly typeImport!: number
    loading = false
    filterSelection = 1
    fields = [
        {
            key: 'selection',
            sortable: false,
            label: '',
            thClass: 'one-line'
        },
        {
            key: 'nameUser',
            sortable: true,
            label: 'Empleado',
            thClass: 'one-line'
        },
        {
            key: 'date',
            sortable: true,
            label: 'Fecha',
            thClass: 'one-line'
        },
        {
            key: 'time',
            sortable: true,
            label: 'Hora',
            thClass: 'one-line'
        },
        {
            key: 'type',
            sortable: true,
            label: 'Tipo de Registro',
            thClass: 'one-line'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '5%'
            }
        }
    ]

    optionsFilter: PropOptionRadio[] = [
        {
            text: 'MOSTRAR TODOS',
            value: 1
        },
        {
            text: 'MOSTRAR SOLO NO REGISTRADOS EN SISTEMA',
            value: 2
        },
        {
            text: 'MOSTRAR SOLO REGISTRADOS EN SISTEMA',
            value: 3
        }
    ]

    selection: AssistanceDevice[] = []

    isInSelection (uid: string): boolean {
        const exists = this.selection.find(a => a.uid === uid)
        if (exists) {
            return true
        }
        return false
    }

    addSelection (assistance: AssistanceDevice) {
        this.selection.push(assistance)
    }

    removeSelection (uid: string) {
        for (let i = 0; i < this.selection.length; i++) {
            const element = this.selection[i]
            if (element.uid === uid) {
                this.selection.splice(i, 1)
                break
            }
        }
    }

    selectAll (isChecked: boolean) {
        if (isChecked) {
            this.assistances.forEach(assistance => {
                if (!assistance.isRegistered && assistance.type > 0) {
                    this.updateSelection(true, assistance)
                }
            })
        } else {
            this.assistances.forEach(assistance => {
                this.removeSelection(assistance.uid)
            })
        }
    }

    updateSelection (isChecked: boolean, assistance: AssistanceDevice) {
        if (isChecked) {
            if (!this.isInSelection(assistance.uid)) {
                this.addSelection(assistance)
            }
        } else {
            this.removeSelection(assistance.uid)
        }
    }

    isValid (): boolean {
        for (let i = 0; i < this.selection.length; i++) {
            if (this.selection[i].type === 0) {
                alerts.error('Debe indicar en su selección que tipo de registro pertenece: INGRESO Ó SALIDA')
                return false
            }
        }
        return true
    }

    async save () {
        if (this.device && this.device > 0 && this.isValid()) {
            loading('show')
            const form: SaveAssistanceDeviceForm = {
                assistance: this.selection.map(a => {
                    let isEmployee = false
                    if (a.employee) {
                        isEmployee = true
                    }
                    return {
                        date: a.date,
                        time: a.time,
                        type: Number(String(a.type)),
                        uid: a.uid === '' ? Number(String(a.employee?.uid)) : Number(a.uid),
                        employee_id: isEmployee && a.employee && a.employee.id ? a.employee.id : null,
                        userUidDevice: this.typeImport === 1 ? Number(a.uid) : (!isEmployee ? a.employee_id : null),
                        nameUser: String(a.nameUser)
                    }
                }),
                deviceId: this.device,
                typeImport: this.typeImport
            }
            const res = await AssistanceService.SaveAssistanceDevice(form)
            if (res.success) {
                alerts.success()
                this.$emit('save-success')
            } else {
                alerts.error(res.msg)
            }
            loading('hide')
        } else {
            alerts.error('Debe seleccionar un dispositivo')
        }
    }

    get assistanceFilter (): AssistanceDevice[] {
        if (this.filterSelection === 1) {
            return this.assistances
        } else if (this.filterSelection === 2) {
            return this.assistances.filter(a => !a.isRegistered)
        } else {
            return this.assistances.filter(a => a.isRegistered)
        }
    }

    get opMarking (): PropOptionSelect[] {
        return OPTIONS_TYPES_MARKING
    }
}
